function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 8,
  width: 60,
  height: 60,
  rx: 30,
  id: "front",
  fill: "#C94780"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.0553 43.227C43.3367 41.9456 42.2979 38.8292 39.7351 36.2664C37.1723 33.7036 34.0559 32.6648 32.7745 33.9462C31.4931 35.2276 32.5319 38.344 35.0947 40.9068C37.6575 43.4696 40.7739 44.5084 42.0553 43.227Z",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.2506 35.1251L24.1106 49.4013C23.9496 49.7496 23.8993 50.139 23.9665 50.5168C24.0338 50.8946 24.2153 51.2426 24.4867 51.514C24.758 51.7853 25.1061 51.9669 25.4839 52.0341C25.8617 52.1014 26.251 52.0511 26.5993 51.8901L40.8756 43.7563",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.7178 32.6251C42.7614 32.6686 42.7961 32.7203 42.8197 32.7773C42.8433 32.8342 42.8555 32.8953 42.8555 32.9569C42.8555 33.0186 42.8433 33.0796 42.8197 33.1366C42.7961 33.1935 42.7614 33.2453 42.7178 33.2888",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.0537 32.625C42.1416 32.5372 42.2607 32.4879 42.385 32.4879C42.5092 32.4879 42.6283 32.5372 42.7162 32.625",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.0517 33.2837C41.9642 33.1954 41.915 33.0761 41.915 32.9518C41.915 32.8275 41.9642 32.7082 42.0517 32.6199",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.7162 33.2838C42.6283 33.3715 42.5092 33.4208 42.385 33.4208C42.2607 33.4208 42.1416 33.3715 42.0537 33.2838",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.0195 27.3175C48.0631 27.3609 48.0978 27.4126 48.1214 27.4694C48.145 27.5263 48.1571 27.5872 48.1571 27.6488C48.1571 27.7103 48.145 27.7713 48.1214 27.8281C48.0978 27.8849 48.0631 27.9366 48.0195 27.98",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.3577 27.3175C47.4011 27.2739 47.4527 27.2393 47.5096 27.2156C47.5664 27.192 47.6274 27.1799 47.6889 27.1799C47.7505 27.1799 47.8114 27.192 47.8683 27.2156C47.9251 27.2393 47.9767 27.2739 48.0202 27.3175",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.3564 27.98C47.3127 27.9366 47.2781 27.8849 47.2545 27.8281C47.2309 27.7713 47.2187 27.7103 47.2188 27.6488C47.2187 27.5872 47.2309 27.5263 47.2545 27.4694C47.2781 27.4126 47.3127 27.3609 47.3564 27.3175",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.0202 27.98C47.9323 28.0678 47.8131 28.1171 47.6889 28.1171C47.5647 28.1171 47.4456 28.0678 47.3577 27.98",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.0195 40.575C48.0632 40.6186 48.0978 40.6703 48.1214 40.7272C48.1451 40.7842 48.1572 40.8452 48.1572 40.9069C48.1572 40.9685 48.1451 41.0296 48.1214 41.0865C48.0978 41.1435 48.0632 41.1952 48.0195 41.2388",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.3577 40.575C47.4456 40.4872 47.5647 40.4379 47.6889 40.4379C47.8131 40.4379 47.9323 40.4872 48.0202 40.575",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.3565 41.2388C47.3128 41.1952 47.2782 41.1435 47.2545 41.0865C47.2309 41.0296 47.2187 40.9685 47.2188 40.9069C47.2187 40.8452 47.2309 40.7842 47.2545 40.7272C47.2782 40.6703 47.3128 40.6186 47.3565 40.575",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.0202 41.2387C47.9323 41.3265 47.8131 41.3758 47.6889 41.3758C47.5647 41.3758 47.4456 41.3265 47.3577 41.2387",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.4363 28.6425C33.5238 28.7308 33.573 28.8501 33.573 28.9744C33.573 29.0987 33.5238 29.218 33.4363 29.3063",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.7722 28.6425C32.8601 28.5547 32.9792 28.5054 33.1035 28.5054C33.2277 28.5054 33.3468 28.5547 33.4347 28.6425",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.7732 29.3063C32.7296 29.2627 32.6949 29.211 32.6713 29.154C32.6477 29.0971 32.6355 29.036 32.6355 28.9744C32.6355 28.9127 32.6477 28.8517 32.6713 28.7947C32.6949 28.7378 32.7296 28.6861 32.7732 28.6425",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.4347 29.3062C33.3468 29.394 33.2277 29.4433 33.1035 29.4433C32.9792 29.4433 32.8601 29.394 32.7722 29.3062",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.0717 23.9375C39.3356 26.2999 39.1096 28.6913 38.408 30.9625",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.7104 25.66L43.0479 28.9737",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.0628 36.9288C49.7004 36.6649 47.309 36.8909 45.0378 37.5925",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.3394 32.2888L47.0256 32.9513",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 76,
  height: 76,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgAnswerCorrect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerCorrect);
export default __webpack_public_path__ + "static/media/answer-correct.18c655c2.svg";
export { ForwardRef as ReactComponent };